import { useEffect } from "react";

// Casual-user deterrents only — NOT real protection. The PDF itself is
// served from a public Storage URL (the same link emailed to leads for
// direct download), so anyone who opens the browser's Network tab can
// still find and fetch it regardless of anything JS on this page does.
export default function CopyProtectionGuard() {
  useEffect(() => {
    function blockContextMenu(e) {
      e.preventDefault();
    }

    function blockDragStart(e) {
      e.preventDefault();
    }

    function blockShortcuts(e) {
      const key = e.key.toLowerCase();
      const ctrlOrCmd = e.ctrlKey || e.metaKey;

      const isDevtools =
        key === "f12" ||
        (ctrlOrCmd && e.shiftKey && ["i", "j", "c"].includes(key));
      const isViewSourceOrSave = ctrlOrCmd && ["u", "s"].includes(key);

      if (isDevtools || isViewSourceOrSave) {
        e.preventDefault();
      }
    }

    document.addEventListener("contextmenu", blockContextMenu);
    document.addEventListener("dragstart", blockDragStart);
    document.addEventListener("keydown", blockShortcuts);

    return () => {
      document.removeEventListener("contextmenu", blockContextMenu);
      document.removeEventListener("dragstart", blockDragStart);
      document.removeEventListener("keydown", blockShortcuts);
    };
  }, []);

  return null;
}
